var _g, _ellipse, _ellipse2, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgOops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195.422,
    height: 335.828,
    viewBox: "0 0 195.422 335.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-555 -239)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(555 343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5,41.971h-.878c18.2-.059,35.281-2.045,48.092-5.593,6.238-1.728,11.133-3.734,14.549-5.964,3.537-2.309,5.331-4.76,5.331-7.286,0-2.544-1.819-5.012-5.407-7.335-3.465-2.244-8.426-4.259-14.745-5.99-13-3.559-30.273-5.519-48.652-5.519S39.13,6.243,26.135,9.8c-6.319,1.731-11.28,3.746-14.745,5.99C7.8,18.115,5.983,20.583,5.983,23.127c0,3.6,3.712,7.093,10.733,10.111,6.836,2.939,16.478,5.3,27.884,6.827C31.477,38.412,20.353,35.78,12.43,32.457,4.3,29.046,0,25.079,0,20.985a7.056,7.056,0,0,1,1.554-4.229,17.153,17.153,0,0,1,4.457-3.939,42.389,42.389,0,0,1,7.053-3.565,84.4,84.4,0,0,1,9.341-3.106,164.754,164.754,0,0,1,24.315-4.5A259.634,259.634,0,0,1,76.5,0a259.634,259.634,0,0,1,29.776,1.649,164.753,164.753,0,0,1,24.315,4.5,84.4,84.4,0,0,1,9.341,3.106,42.39,42.39,0,0,1,7.053,3.565,17.154,17.154,0,0,1,4.457,3.939,7.056,7.056,0,0,1,1.554,4.229,7.056,7.056,0,0,1-1.554,4.229,17.154,17.154,0,0,1-4.457,3.939,42.389,42.389,0,0,1-7.053,3.565,84.4,84.4,0,0,1-9.341,3.106,164.75,164.75,0,0,1-24.315,4.5A259.631,259.631,0,0,1,76.5,41.971Z",
    transform: "translate(23.06 25.724)",
    fill: "#bfcbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.584,8.636a1.876,1.876,0,0,1,3.2,1.85h0a1.876,1.876,0,0,0,1.447,2.507h0a1.876,1.876,0,0,1,0,3.7h0A1.876,1.876,0,0,0,21.789,19.2h0a1.876,1.876,0,0,1-3.2,1.85h0a1.876,1.876,0,0,0-2.895,0h0a1.876,1.876,0,0,1-3.2-1.85h0a1.876,1.876,0,0,0-1.447-2.507h0a1.876,1.876,0,0,1,0-3.7h0a1.876,1.876,0,0,0,1.447-2.507h0a1.876,1.876,0,0,1,3.2-1.85h0a1.876,1.876,0,0,0,2.895,0Z",
    transform: "translate(68.757 0) rotate(30)",
    fill: "#00f2fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.408,5.263A1.147,1.147,0,0,1,13.365,6.4l0,.01a1.147,1.147,0,0,0,.885,1.534h0a1.147,1.147,0,0,1,0,2.262h0a1.147,1.147,0,0,0-.885,1.534l0,.01a1.147,1.147,0,0,1-1.957,1.134l-.016-.019a1.147,1.147,0,0,0-1.767,0l-.016.019a1.147,1.147,0,0,1-1.957-1.134l0-.01A1.147,1.147,0,0,0,6.77,10.2h0a1.147,1.147,0,0,1,0-2.262h0a1.147,1.147,0,0,0,.885-1.534l0-.01A1.147,1.147,0,0,1,9.609,5.263l.016.019a1.147,1.147,0,0,0,1.767,0Z",
    transform: "matrix(0.588, 0.809, -0.809, 0.588, 182.518, 27.666)",
    fill: "#00f2fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.61,6.278a1.368,1.368,0,0,1,2.335,1.352l0,.012A1.368,1.368,0,0,0,17,9.472h0a1.368,1.368,0,0,1,0,2.7h0A1.368,1.368,0,0,0,15.941,14l0,.012a1.368,1.368,0,0,1-2.335,1.352l-.019-.023a1.368,1.368,0,0,0-2.108,0l-.019.023a1.368,1.368,0,0,1-2.335-1.352l0-.012a1.368,1.368,0,0,0-1.056-1.83h0a1.368,1.368,0,0,1,0-2.7h0a1.368,1.368,0,0,0,1.056-1.83l0-.012a1.368,1.368,0,0,1,2.335-1.352l.019.023a1.368,1.368,0,0,0,2.108,0Z",
    transform: "translate(0 42.7) rotate(-2)",
    fill: "#00f2fe"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.789,
    cy: 95.789,
    rx: 95.789,
    ry: 95.789,
    transform: "translate(558.843 391.249)",
    fill: "#00f2fe"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.697,
    cy: 81.573,
    rx: 89.697,
    ry: 81.573,
    transform: "translate(565 391.249)",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.25,
    cy: 20.674,
    rx: 41.25,
    ry: 20.674,
    transform: "translate(614 397.249)",
    fill: "#fff",
    opacity: 0.71
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(612.894 457.872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6839.662,301.111l20.813,7.936v8.086s.9,11.05-10.032,11.68-10.781-10.482-10.781-10.482Z",
    transform: "translate(-6791.48 -248.382)",
    fill: "#ea4941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.622-20.513S15.085-35.841,40.11-35.841,74.25-20.513,74.25-20.513",
    transform: "translate(2.351 87.521)",
    fill: "none",
    stroke: "#323141",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.622-15.082s8.473-11.27,33.5-11.27,32.7,13.431,32.7,13.431",
    transform: "translate(2.351 82.09)",
    fill: "none",
    stroke: "#323141",
    strokeLinecap: "round",
    strokeWidth: 8,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 19.965,
    y2: 19.965,
    fill: "none",
    stroke: "#323141",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.965,
    y2: 19.965,
    fill: "none",
    stroke: "#323141",
    strokeLinecap: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.722 0)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 19.965,
    y2: 19.965,
    transform: "translate(0)",
    fill: "none",
    stroke: "#323141",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.965,
    y2: 19.965,
    transform: "translate(0)",
    fill: "none",
    stroke: "#323141",
    strokeLinecap: "round",
    strokeWidth: 8
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41 10.668)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 74,
    rx: 37,
    transform: "translate(520 228.332)",
    fill: "#010326"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(613 279.332)",
    fill: "aqua",
    fontSize: 36,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -57.654,
    y: 0
  }, "OOPS!")), /*#__PURE__*/React.createElement("path", {
    d: "M21,0,42,36H0Z",
    transform: "translate(635 338.332) rotate(180)",
    fill: "#010326"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOops);
export default __webpack_public_path__ + "static/media/img-oops.6b19cefa75b79917e09251a0a5cf1156.svg";
export { ForwardRef as ReactComponent };